import { render } from "./SystemAlerts.vue?vue&type=template&id=23b72874&scoped=true&ts=true"
import script from "./SystemAlerts.vue?vue&type=script&lang=ts"
export * from "./SystemAlerts.vue?vue&type=script&lang=ts"

import "./SystemAlerts.vue?vue&type=style&index=0&id=23b72874&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b72874"]])

export default __exports__